import * as THREE from 'three/build/three.module';
import { common, params } from './J3RenderData';  //データ変更を容易にするため別名で読込
import { J3ThreeSub } from './J3ThreeSub';
import { J3RenderUtils } from './J3RenderUtils';
import { J3CameraUtils } from './J3CameraUtils';
import { URLHelper} from './XUtils';
import { DeployType } from './J3TypeList';
//import { NoToneMapping } from 'three';
//import { debug } from 'webpack';

type World = { sub: J3ThreeSub };

export class J3ThreeMain {
    renderUtils:J3RenderUtils = null;
    cameraUtils:J3CameraUtils = null;
    param;
    debugLvl:number = 0;
    //targetIndices: number[] = [];
    worlds: World[] = [];
    targetIndex:number = 0;
    container:HTMLElement;
    raycasterTops:THREE.Object3D[] = [];    //レイキャスタ交差チェックのトップオブジェクト
    targetSub:J3ThreeSub;
    useQuery:boolean = false;

    cameraGroupIndex = 0;

    constructor() {
    }

    Rendering() {
        requestAnimationFrame(() => { this.Rendering() });

        for (let i = 0; i < this.worlds.length; i++) {
            if (this.worlds[i].sub.top.visible) {
                this.worlds[i].sub.Update();
            }
        }

        // 
        const targetCameraParam = this.param.camera.group[this.cameraGroupIndex];
        const updateControls = targetCameraParam.orbitControl.enable;  //カメラオービットコントロールの使用
        let updateCameraAnimation = false;
        updateCameraAnimation = targetCameraParam?.animation?.enable;    //カメラアニメーションの適用
        //const useRaycaster = this.param.domes.enable;           //レイキャストの使用
        const useRaycaster = this.param.overall.raycaster.useRaycast;     //レイキャストを有効にすると負荷が大きい
        //let markerPrefix = 'm';   //ダミーのプレフィクス
        //if(this.param.domes.enable) markerPrefix = this.param.domes.marker.prefix;
        //const tagPrefix = this.param.overall.raycaster.tagPrefix;
        //console.log(updateControls, useRaycaster);
        //console.log(this.j3RenderUtils.camera.position, this.j3RenderUtils.camera.lookAt);
        const pDomes = this.param.domes;
        const pTags = this.param.tags;
        const pBills = this.param.billboards;
        const pBill2Ds = this.param.billboard2D;
        if (this.renderUtils != null) this.renderUtils.Render(updateControls, updateCameraAnimation, useRaycaster, pDomes, pTags, pBills, pBill2Ds, this.targetSub.raycasterTop);
    }

    Init() {
        console.log('ThreeJSPanel:Init');

        //パラメータデータの設定
        this.targetIndex = common.targetIndex;
        if (this.targetIndex > params.length - 1) {
            this.targetIndex = params.length - 1;
        }else if (this.targetIndex < 0){
            this.targetIndex = 0;
        }

        this.param = params[this.targetIndex];   //初期パラメータ
        //デバッグレベル（後でlocalhostかどうかで上書き）
        this.debugLvl = this.param.debug.level;

        let urlHelper = new URLHelper();
        // 開発環境か本番環境か
        let deploy:DeployType;
        if(urlHelper.getHostName() == 'localhost'){
            deploy = 'development';
        }else{
            deploy = 'production';
            if(this.param.debug.clearForProduction) this.param.debug.level = 0; //プロダクション用にデバッグレベルをクリア
        }
        console.log(deploy, 'debugLvl', this.debugLvl);
        if(this.debugLvl > 0) console.log(this.param);

        //クエリパラメータ
        this.useQuery = this.param.overall.query;
        let _skipModels:boolean = false;    //true：モデル・タグをスキップし、直接ドームへ
        //let _virtualTagIndex:number;    //モデル・タグスキップ（_skipModels=true）時に仮想的にクリックするタグのインデックス
        let _actionParam = undefined;

        if(this.useQuery){
            _skipModels = urlHelper.getParamByNameToBoolean('skipmodels', true, false);
            //_initialDome = urlHelper.getParamByName('initialdome');
            //_virtualTagIndex = urlHelper.getParamByNameToInt('virtualtagindex', true, undefined);
            //const _domeName:string = urlHelper.getParamByName('domename', true);
            if(_skipModels){
                const _domeNo:Number = urlHelper.getParamByNameToInt('domeno', true, 186);  // initialConnectsに指定するドーム番号
                this.param.domes.initialConnects = [_domeNo];
                const _domeName:string = this.param.domes.spherePrefix + _domeNo.toString().padStart(3,'0') + '.jpg';   //ドーム番号からドーム画像ファイル名へ
                console.log('_domeName',_domeName, 'this.param.domes.initialConnects',this.param.domes.initialConnects);
                const _angle:number[] = urlHelper.getParamByNameToArray('angle', true, [0,0,0]);
                const _distance:number = urlHelper.getParamByNameToFloat('distance', true, 1.0);
                _actionParam = {name:_domeName, angle:_angle, distance:_distance}; 
                if(!_actionParam.name || !Array.isArray(_angle)) _skipModels = false; //_actionParamが定義されていない場合は_skipModelsをtrueに
            }
            console.log('useQuery: _skipModels', _skipModels, '_actionParam',_actionParam );
        }

        // HTMLパラメータの上書き（HTML Title）
        const html = this.param.overall.html;
        const title = document.querySelector('title');
        if(title) title.textContent = html.title;

        // シーン作成
        const scene = new THREE.Scene();
        // シーン背景色
        const pScene = this.param.overall.scene;
        if(pScene != undefined && pScene.bgColor != undefined){
            const bgColor = new THREE.Color(pScene.bgColor);
            scene.background = bgColor;
        }

        //サブシーンのトップオブジェクト
        const obj3d = new THREE.Object3D();   
        scene.add(obj3d);

        // RenderUtilsの作成
        const containerID = 'container';
        this.container = document.getElementById(containerID) as HTMLElement;
        const pOverall = this.param.overall;
        const pCamera = this.param.camera;
        this.targetSub = new J3ThreeSub(this.debugLvl, this.param, scene, obj3d);

        if(pOverall.renderer.disable != true) {
            this.renderUtils = new J3RenderUtils(scene, this.container, pOverall.renderer);
            //カメラ
            const cameraUtils  = new J3CameraUtils(this.renderUtils, pCamera.fov, 1.0, pCamera.position, pCamera.lookat, pCamera.near, pCamera.far);
            this.renderUtils.cameraUtils = cameraUtils;
            this.targetSub.cameraUtils = cameraUtils;
        }
        //
       
        this.targetSub.Init(this.renderUtils, _skipModels, _actionParam);
        //レイキャスター用にタグヘルパのラッパー配列を取得
        for(const tagHelper of this.targetSub.tagHelpers){
            this.raycasterTops.push(tagHelper.tagWrapper);
        }
        //
        this.targetSub.container = this.container;
        this.targetSub.SetCameraParams(pCamera.initialIndex);   //カメラパラメータの配列のどれを初期設定にするかのインデックス
        this.worlds.push({ sub: this.targetSub });

        //初期ワールドの指定（0）
        console.log('this.worlds.length', this.worlds.length, 'common.initialIndex', common.targetIndex);
        //this.SelectWorld(targetIndex);
        this.Rendering();
    }
}